import { i18n, router } from "@/config"
import { flow } from "lodash-es"
import { getAuthHeaders, setAuthCookies, getAccessToken } from "@/helpers/auth"

import { signOutOnError, honeybadgerRequestNotify, redirectOnError, showErrorToast } from "./errorHandlers"

const getHeader = (headers, name) => {
  if (!headers) return undefined
  if (typeof headers.get === "function") return headers.get(name)
  return headers[name] || headers.common?.[name]
}

const setHeaders = (config, values) => {
  Object.entries(values).forEach(([key, value]) => {
    if (value == null) return
    if (typeof config.headers.set === "function") {
      config.headers.set(key, value)
    } else {
      config.headers[key] = value
    }
  })
  return config
}

const localeRequestInterceptor = config => {
  return setHeaders(config, { locale: i18n.locale })
}

const pageRequestInterceptor = config => {
  const currentPage = getHeader(config.headers, "currentPage") || router.currentRoute.meta.permissionType || "sign_in"

  return setHeaders(config, { currentPage })
}

const authRequestInterceptor = config => {
  return setHeaders(config, getAuthHeaders())
}

const authResponseInterceptor = response => {
  setCookiesRequestHeaders(response.headers)

  return response
}

export const errorInterceptor = error => {
  if (error.response?.headers) {
    setCookiesRequestHeaders(error.response.headers)
  }

  const { skipErrorToast } = error.config || {}
  const shouldNotify = !signOutOnError(error) && !redirectOnError(error)

  if (shouldNotify && process.env.VUE_APP_HONEYBADGER_ENABLED === "true") honeybadgerRequestNotify(error)
  if (!skipErrorToast) showErrorToast(error)

  return Promise.reject(error)
}

const setCookiesRequestHeaders = headers => {
  const client = getHeader(headers, "client")
  const uid = getHeader(headers, "uid")
  const expiry = getHeader(headers, "expiry")
  const tokenType = getHeader(headers, "token-type")
  const accessToken = getHeader(headers, "access-token") || getAccessToken()
  if (client) {
    setAuthCookies({ client, accessToken, uid, tokenType, expiry })
  }
}

export const requestInterceptor = flow([authRequestInterceptor, localeRequestInterceptor, pageRequestInterceptor])
export const responseInterceptor = flow([authResponseInterceptor])
